import { z } from 'zod'

/**
 * Schema para dirección
 * Reutilizable en Client y Viatger
 */
export const addressSchema = z.object({
  adreca: z.string().optional(),
  ciutat: z.string().optional(),
  provincia: z.string().optional(),
  codi_postal: z.string().optional(),
  pais: z.string().optional(),
})

export type AddressFormData = z.infer<typeof addressSchema>
